import { render, staticRenderFns } from "./SectionEducational.vue?vue&type=template&id=001ee654&"
import script from "./SectionEducational.vue?vue&type=script&lang=js&"
export * from "./SectionEducational.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports